import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/user-48.jpg'


const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-xl-4 col-lg-3 col-md-4" }
const _hoisted_3 = { class: "col-xl-8 col-lg-9 col-md-8" }
const _hoisted_4 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_5 = { class: "card-body p-4" }
const _hoisted_6 = { class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap border-bottom pb-3 mb-4" }
const _hoisted_7 = { class: "d-flex position-relative top-3" }
const _hoisted_8 = { class: "pe-0 border-0 bg-transparent ms-4 ps-2" }
const _hoisted_9 = { class: "pe-0 border-0 bg-transparent ms-2" }
const _hoisted_10 = { class: "pe-0 border-0 bg-transparent ms-2" }
const _hoisted_11 = { class: "dropdown action-opt ms-2 position-relative top-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmailSidebar = _resolveComponent("EmailSidebar")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_EmailSidebar)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "fs-16 fw-semibold mb-0" }, "Sales Review Meeting", -1)),
            _createElementVNode("div", _hoisted_7, [
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_8, _cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-body hover" }, " archive ", -1)
              ]))), [
                [
                  _directive_b_tooltip,
                  'Archive',
                  void 0,
                  {
                    hover: true,
                    top: true
                  }
                ]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_9, _cache[1] || (_cache[1] = [
                _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-body hover" }, " help_clinic ", -1)
              ]))), [
                [
                  _directive_b_tooltip,
                  'Help',
                  void 0,
                  {
                    hover: true,
                    top: true
                  }
                ]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_10, _cache[2] || (_cache[2] = [
                _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-body hover" }, " delete ", -1)
              ]))), [
                [
                  _directive_b_tooltip,
                  'Trash',
                  void 0,
                  {
                    hover: true,
                    top: true
                  }
                ]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, _cache[3] || (_cache[3] = [
                _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-20 text-body hover\"> more_vert </i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
              ]))), [
                [
                  _directive_b_tooltip,
                  'More_Option',
                  void 0,
                  {
                    hover: true,
                    top: true
                  }
                ]
              ])
            ])
          ]),
          _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center mb-4 pb-md-3\"><div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><img src=\"" + _imports_0 + "\" class=\"wh-45 rounded-circle\" alt=\"user\"></div><div class=\"flex-grow-1 ms-3 position-relative top-2\"><h4 class=\"mb-0 fs-14 fw-semibold\">Sarah Smith</h4><span>sarah@gmail.com</span></div></div><span><i class=\"ri-star-line fs-18 text-body me-1\"></i> 26 March,2024 </span></div><div class=\"ps-sm-5 ms-sm-2\"><h5 class=\"fs-14 fw-semibold mb-3 mb-md-4\"> Subject: Re: Quarterly Sales Review Meeting </h5><span class=\"fw-medium text-secondary d-block mb-4\">Hi Smith,</span><p> Great, I&#39;ll go ahead and send out the calendar invite shortly. </p><p> Regarding the agenda, I think your suggestions are spot on. I&#39;ll add them to the agenda and circulate it to everyone before the meeting so they can come prepared. </p><p> Additionally, I think it would be beneficial to have a brief update on any new products or promotions that are launching in the next quarter. This will give us a comprehensive view of our sales strategy moving forward. </p><p> Let me know if you think that&#39;s a valuable addition to the agenda. </p><div class=\"border-bottom pb-4 mb-4 mt-4 mt-md-5\"><h5 class=\"fs-14 fw-medium mb-2\">Best regards,</h5><h5 class=\"fs-14 fw-medium mb-0\">Olivia Parker</h5></div><div class=\"d-flex flex-wrap gap-3\"><button class=\"btn btn-primary fs-16 fw-medium px-3\"> Reply </button><button class=\"btn btn-outline-primary fs-16 fw-medium px-3\"> Forward </button></div></div>", 2))
        ])
      ])
    ])
  ]))
}